export default __webpack_public_path__ + "static/media/Women-2.727abcf8.svg";